var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"imgDialog",attrs:{"visible":_vm.visible,"width":"35%","show-close":false},on:{"close":_vm.handleClose,"update:visible":function($event){_vm.visible=$event}}},[_c('i',{staticClass:"el-icon-circle-close closeIcon",on:{"click":_vm.handleClose}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }